import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('appLanguage') || 'english';
  });

  useEffect(() => {
    localStorage.setItem('appLanguage', language);
    
    // Set language attribute
    if (language === 'english') {
      document.documentElement.lang = 'en';
    } else if (language === 'hindi') {
      document.documentElement.lang = 'hi';
    } else if (language === 'arabic') {
      document.documentElement.lang = 'ar';
    }
    
    // Set text direction (RTL for Arabic)
    if (language === 'arabic') {
      document.documentElement.dir = 'rtl';
    } else {
      document.documentElement.dir = 'ltr';
    }
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
